// Scholarship dataset with source/verification metadata.
// Demo data — deadlines/funding must be re-verified from official sources before production use.
// Demo deadlines are generated relative to today so the countdown/reminder feature stays live.
const inDays = (n) => {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
};

export const scholarships = [
  {
    id: "chevening",
    name: "Chevening Scholarship",
    provider: "UK Government (FCDO)",
    country: "United Kingdom",
    countryCode: "GB",
    degree: "Master",
    field: ["Any", "Computer Science", "Business", "Public Policy", "Engineering"],
    funding: "Fully Funded",
    deadline: inDays(18),
    language: { test: "IELTS", min: 6.5 },
    minGpa: 3.0,
    experienceYears: 2,
    citizenship: "Indonesia eligible",
    tagline: "Beasiswa penuh S2 di UK untuk calon pemimpin masa depan.",
    status: "CURRENT",
    source_url: "https://www.chevening.org/",
    source_name: "Chevening Official",
    source_type: "P0 Official Provider",
    published_date: "2025-08-01",
    updated_date: "2025-09-10",
    verified_date: "2025-09-10",
    cycle: "2025/2026",
    confidence: "High",
    evidence_note: "Requirements summarised from official site; verify eligibility yearly.",
    overview:
      "Chevening adalah program beasiswa global Pemerintah Inggris yang mendanai penuh studi S2 selama satu tahun di universitas mana pun di UK.",
    documents: ["Ijazah & Transkrip", "2 Referensi", "4 Esai Chevening", "Unconditional Offer (nanti)", "IELTS/TOEFL"],
    benefits: ["tuition", "living", "flight", "visa", "insurance"],
  },
  {
    id: "lpdp",
    name: "LPDP (Reguler Luar Negeri)",
    provider: "Kementerian Keuangan RI",
    country: "Berbagai Negara",
    countryCode: "ID",
    degree: "Master",
    field: ["Any", "Computer Science", "Engineering", "Science", "Health"],
    funding: "Fully Funded",
    deadline: inDays(11),
    language: { test: "IELTS", min: 6.5 },
    minGpa: 3.0,
    experienceYears: 0,
    citizenship: "Indonesia only",
    tagline: "Beasiswa penuh Pemerintah Indonesia untuk S2/S3 dalam & luar negeri.",
    status: "CURRENT",
    source_url: "https://lpdp.kemenkeu.go.id/",
    source_name: "LPDP Official",
    source_type: "P3 Official Ministry",
    published_date: "2025-06-01",
    updated_date: "2025-09-01",
    verified_date: "2025-09-01",
    cycle: "2025 Tahap 2",
    confidence: "High",
    evidence_note: "Skema & syarat berubah tiap tahap; verifikasi di situs LPDP.",
    overview:
      "LPDP membiayai penuh pendidikan pascasarjana bagi WNI di universitas tujuan terbaik dunia, termasuk biaya hidup dan pendukung.",
    documents: ["KTP", "Ijazah & Transkrip", "Sertifikat Bahasa", "Esai Kontribusi", "LoA (jika ada)", "Surat Rekomendasi"],
    benefits: ["tuition", "living", "flight", "insurance", "book", "research", "settlement"],
  },
  {
    id: "erasmus",
    name: "Erasmus Mundus Joint Master",
    provider: "European Commission",
    country: "Eropa",
    countryCode: "EU",
    degree: "Master",
    field: ["Any", "Computer Science", "Engineering", "Data Science"],
    funding: "Fully Funded",
    deadline: inDays(74),
    language: { test: "IELTS", min: 6.5 },
    minGpa: 3.0,
    experienceYears: 0,
    citizenship: "Open",
    tagline: "Studi S2 di 2+ negara Eropa dengan pendanaan penuh Uni Eropa.",
    status: "CURRENT",
    source_url: "https://www.eacea.ec.europa.eu/scholarships/emjm-catalogue_en",
    source_name: "EACEA Official",
    source_type: "P3 International Organization",
    published_date: "2025-07-01",
    updated_date: "2025-08-20",
    verified_date: "2025-08-20",
    cycle: "2026 Intake",
    confidence: "Medium",
    evidence_note: "Tiap program EMJM punya deadline & syarat sendiri.",
    overview:
      "Erasmus Mundus adalah program master gabungan bergengsi yang diselenggarakan konsorsium universitas Eropa dengan mobilitas antarnegara.",
    documents: ["Ijazah & Transkrip", "CV", "Motivation Letter", "Sertifikat Bahasa", "2 Rekomendasi"],
    benefits: ["tuition", "living", "flight", "insurance", "settlement"],
  },
  {
    id: "australia-awards",
    name: "Australia Awards Scholarship",
    provider: "Australian Government (DFAT)",
    country: "Australia",
    countryCode: "AU",
    degree: "Master",
    field: ["Any", "Public Policy", "Health", "Infrastructure", "Education"],
    funding: "Fully Funded",
    deadline: inDays(150),
    language: { test: "IELTS", min: 6.5 },
    minGpa: 2.9,
    experienceYears: 2,
    citizenship: "Indonesia eligible",
    tagline: "Beasiswa penuh Pemerintah Australia untuk pembangunan.",
    status: "CURRENT",
    source_url: "https://www.australiaawardsindonesia.org/",
    source_name: "Australia Awards Indonesia",
    source_type: "P2 Official Government",
    published_date: "2025-09-01",
    updated_date: "2025-09-15",
    verified_date: "2025-09-15",
    cycle: "2026 Intake",
    confidence: "Medium",
    evidence_note: "Prioritas bidang berubah tiap tahun.",
    overview:
      "Australia Awards mendanai studi pascasarjana di universitas Australia dengan fokus pada bidang prioritas pembangunan.",
    documents: ["KTP/Paspor", "Ijazah & Transkrip", "IELTS", "CV", "Statement"],
    benefits: ["tuition", "living", "flight", "insurance", "settlement"],
  },
  {
    id: "mext",
    name: "MEXT Scholarship",
    provider: "Government of Japan (MEXT)",
    country: "Jepang",
    countryCode: "JP",
    degree: "Master",
    field: ["Any", "Engineering", "Science", "Computer Science"],
    funding: "Fully Funded",
    deadline: inDays(205),
    language: { test: "IELTS", min: 5.5 },
    minGpa: 3.0,
    experienceYears: 0,
    citizenship: "Indonesia eligible",
    tagline: "Beasiswa Pemerintah Jepang, tersedia jalur riset & universitas.",
    status: "CURRENT",
    source_url: "https://www.id.emb-japan.go.jp/",
    source_name: "Kedutaan Jepang",
    source_type: "P2 Official Government",
    published_date: "2025-04-01",
    updated_date: "2025-05-10",
    verified_date: "2025-05-10",
    cycle: "2026 Intake",
    confidence: "Medium",
    evidence_note: "Persyaratan bahasa bervariasi antara jalur Kedutaan & Universitas.",
    overview:
      "MEXT membiayai studi di Jepang termasuk tuisi, tunjangan bulanan, dan tiket, dengan opsi kelas bahasa Jepang.",
    documents: ["Ijazah & Transkrip", "Field of Study Plan", "Rekomendasi", "Sertifikat Bahasa"],
    benefits: ["tuition", "living", "flight", "language"],
  },
  {
    id: "ggs",
    name: "Gates Cambridge (Reference)",
    provider: "University of Cambridge",
    country: "United Kingdom",
    countryCode: "GB",
    degree: "Master",
    field: ["Any", "Science", "Computer Science", "Engineering"],
    funding: "Fully Funded",
    deadline: null,
    language: { test: "IELTS", min: 7.0 },
    minGpa: 3.6,
    experienceYears: 0,
    citizenship: "Open",
    tagline: "Beasiswa sangat kompetitif di University of Cambridge.",
    status: "UNVERIFIED",
    source_url: "https://www.gatescambridge.org/",
    source_name: "Gates Cambridge",
    source_type: "P1 Official University",
    published_date: null,
    updated_date: null,
    verified_date: null,
    cycle: "Unknown",
    confidence: "Low",
    evidence_note: "Deadline & detail belum diverifikasi ulang untuk siklus ini.",
    overview:
      "Gates Cambridge mendanai penuh studi pascasarjana di Cambridge bagi kandidat luar biasa dengan potensi kepemimpinan.",
    documents: ["Transkrip", "Referensi", "Research Proposal", "Sertifikat Bahasa"],
    benefits: ["tuition", "living", "flight", "family"],
  },
];

export const findScholarship = (id) => scholarships.find((s) => s.id === id);
